import React from 'react'

import { Portlet, Form, Col, Row, Button } from '_zari/core'

import { Formik } from 'formik'

import * as FormGroups from './formGroups'
// import * as Modals from './modals'

import { ZariContext } from '_zari/context'
import { AdminContext } from 'contexts/AdminContext'

import * as AsientosContablesService from 'services/asientosContables.service'

const MainForm = ({ setMostrarPaginadoModal, setMesContabilidad }) => {
  const __zariContext = React.useContext(ZariContext)
  const __adminContext = React.useContext(AdminContext)

  const formInitialValues = {
    mes: __adminContext.mesTrabajo || ''
  }

  const submitHandler = (formData, { setSubmitting }) => {
    if (!formData.mes) {
      __zariContext.snack('error', 'Escoge un periodo, por favor.')
      setSubmitting(false)
      return
    }

    AsientosContablesService.sireObtenerPaginado({ periodo: formData.mes })
      .then(({ data }) => {
        if (data.errors) {
          __zariContext.snack('error', data.msg)
        } else {
          setMostrarPaginadoModal(false)
          setMesContabilidad(formData.mes)
          setMostrarPaginadoModal(true)
        }
      })
      .catch(({ data: { error } }) => {
        __zariContext.snack('error', error)
      })
      .finally(() => {
        setSubmitting(false)
      })
  }

  return (
    <>
      <Portlet>
        <Portlet.Header title='Lista Comprobantes' />
        <Portlet.Body>
          <Row>
            <Col md={12}>
              <Formik initialValues={formInitialValues} onSubmit={submitHandler}>
                {({ errors, touched, isSubmitting, handleSubmit }) => (
                  <Form>
                    <Row>
                      <Col md={12}>
                        <FormGroups.MesContabilidadFormGroup />
                      </Col>
                    </Row>
                    <Row>
                      <Col md={12} className='text-right'>
                        <Button disabled={isSubmitting} onClick={handleSubmit}>
                          Mostrar Listado
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                )}
              </Formik>
            </Col>
          </Row>
        </Portlet.Body>
      </Portlet>
      {/* {mostrarPaginadoModal && (
        <Modals.MostrarPaginadoModal show={mostrarPaginadoModal} handleClose={() => setMostrarPaginadoModal(false)} periodo={mesContabilidad} />
      )} */}
    </>
  )
}

export default React.memo(MainForm)
